import $ from 'jquery';
import Api from '../util/Api';
import Popup from '../util/Popup';

function showPaymentForm(orderId)
{
    Popup.showWithContent('<h2>Loading...</h2>', 600);
    Api.post('/api/order/payment/', { ID: orderId }).then((response) => {
        Popup.showWithContent(response, 600);
    });
}

const newOrder = $('.js-personal-order-new');
if (newOrder.length) {
    const orderId = newOrder.data('orderId');
    showPaymentForm(orderId);
}

$('.js-personal-order-items').click(function () {
    const orderId = $(this).parents('.accordion--order').attr('data-order-id');
    Popup.notify('<h2>Loading...</h2>');
    Api.post('/api/order/items/', { ID: orderId }).then((response) => {
        Popup.showWithContent(response);
    });
});

$('.js-personal-order-payment').click(function () {
    const orderId = $(this).parents('.accordion--order').attr('data-order-id');
    showPaymentForm(orderId);
});

// $('.js-personal-order-cancel').click(function (e) {
//     e.preventDefault();
//
//     if (window.confirm('Вы точно хотите отменить заказ?')) {
//         const orderId = $(this).parents('.accordion--order').attr('data-order-id');
//         $(this).addClass('disabled');
//
//         Api.post('/api/order/cancel/', { order_id: orderId })
//             .then((response) => {
//                 if (response.isError) {
//                     Popup.notify(response.error);
//                     $(this).removeClass('disabled');
//                 } else {
//                     if (response.message) {
//                         Popup.notify(response.message);
//                     }
//                     setTimeout(() => {
//                         window.location.reload();
//                     }, 1200);
//                 }
//             });
//     }
// });
